export default {
  type: Object.freeze({
    CLINIC: 'clinic', DENTAL_LABORATORY: 'dental-laboratory', CLINIC_DENTAL_LABORATORY: 'clinic-dental-laboratory',
    CLINIC_LABEL: 'Клиника', DENTAL_LABORATORY_LABEL: 'Зуботехническая лаборатория',
    CLINIC_DENTAL_LABORATORY_LABEL: 'Клиника/Зуботехническая лаборатория'
  }),
}
